// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelNurseAssessments extends React.Component<Props> {
  get outcomesData() {
    return [
      {
        id: "continue-treatment",
        label: this.props.t("CONTINUE_TREATMENT"),
        details: this.props.t("CONTINUE_TREATMENT_DESCRIPTION"),
      },
      {
        id: "self-care",
        label: this.props.t("SELF_CARE"),
        details: this.props.t("SELF_CARE_DESCRIPTION"),
      },
      {
        id: "gp-or-dentist",
        label: this.props.t("GP_OR_DENTIST"),
        details: this.props.t("GP_OR_DENTIST_DESCRIPTION"),
      },
      {
        id: "service",
        label: this.props.t("ONE_ONE_ONE_SERVICE"),
        details: this.props.t("ONE_ONE_ONE_SERVICE_DESCRIPTION"),
      },
      {
        id: "walk-in-clinick",
        label: this.props.t("WALK_IN_CLINIC"),
        details: this.props.t("WALK_IN_CLINIC_DESCRIPTION"),
      },
      {
        id: "emergency",
        label: this.props.t("EMERGENCY"),
        details: this.props.t("EMERGENCY_DESCRIPTION"),
      },
    ];
  }

  get recommendationsData() {
    return [
      {
        id: "promote-engagement",
        label: this.props.t("ENCOURAGE_ENGAGEMENT"),
        details: this.props.t("PROMOTE_ENGAGEMENT_DESCRIPTION"),
      },
      {
        id: "initiaves",
        label: this.props.t("REFLECT_ON_INITIATIVES"),
        details: this.props.t("REFLECT_ON_INITIATIVES_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  get recommendationsColumns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
        columnClassName: "bg-mint",
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("NURSE_ASSESSMENTS_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.NURSE_ASSESSMENTS_INSTRUCTIONS}
            title={this.props.t("NURSE_ASSESSMENTS_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("OUTCOMES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.outcomesData} />
        <h6 className="font-weight-bold">{this.props.t("RECOMMENDATIONS")}</h6>
        <SimpleGrid
          className="theme-help"
          columns={this.recommendationsColumns}
          rows={this.recommendationsData}
        />
      </div>
    );
  }
}

export default localize()(HelpPanelNurseAssessments);
